import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ArchiveWarnings } from 'src/app/model/archive-warnings.model';

@Component({
    selector: 'edl-modal-archive-item',
    styleUrls: ['edl-modal-archive-item.component.scss'],
    templateUrl: './edl-modal-archive-item.component.html'
})
export class EdlModalArchiveItem implements OnInit {
    @Input() title: string;
    @Input() message: string;
    @Input() archiveWarnings: ArchiveWarnings;

    warnings: string[];

    constructor(public activeModal: NgbActiveModal) {}

    ngOnInit() {
        this.warnings = this.getArchiveWarningMessages(this.archiveWarnings);
    }

    private getArchiveWarningMessages(archiveWarnings: ArchiveWarnings) {
        const warnings = [];

        if (archiveWarnings?.AreItemsPending) {
            warnings.push('This item may have users that are pending approval.  Before archiving, please consider approving users.');
        }

        if (archiveWarnings?.IsAct48Pending) {
            warnings.push('This item has Act 48 submissions that are pending or have been returned in error.  Before archiving, please consider correcting Act 48 submission errors.');
        }

        if (archiveWarnings?.HasRecurrence) {
            warnings.push('This item has recurrence and will no longer generate new cycles after being archived.');
        }

        return warnings;
    }

}